/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable arrow-body-style */

import React from 'react'
import Image from 'next/image'
import { convertToSlug } from 'src/utils/IdGenerator'
import Button from '@components/Button/button'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import assetLoader from '@utils/internalImageLoader'
import styles from './googleRating.module.scss'
import RatingPreview from './ratingPreview'
import SeeReviews from './seeReviews'

const googleRating = ({ data, result }) => {
  const widgetData = data?.data?.attributes

  // Extract the h2 content from widgetHeading
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = widgetData?.widgetHeading?.match(h2Regex)
  const h2Content = matches ? matches[1] : null

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.googleRatingRootContainer} white skip-child`} id={convertToSlug(h2Content)}>
        <div className={styles.googleRatingContainer}>
          <Image
            src={`${assetLoader()}/images/google-rating-background.svg`}
            width={1072}
            height={246}
            alt="oogle-rating-background"
            className={styles.backgroundImageGoogleRating}
            loading="lazy"
          />
          <div className={styles.mainWidgetSection}>
            {/* Google Icon */}
            <div className={styles.imageContainer}>
              <Image
                src={`${assetLoader()}/images/social-google.svg`}
                alt="Google Rating icon"
                width={96}
                height={96}
                loading="lazy"
              />
            </div>
            {/* Google Main Rating info */}
            <div className={styles.googleMainRatingInfo}>
              <RatingPreview value={result?.rating || 4.7} />
              <h3 className={styles.mainHeading}>{widgetData?.widgetHeading || 'Read what our users have to say'}</h3>
              <p className={styles.mainPara}>{`Rated ${result?.rating || 4.7}/5 with over ${
                result?.user_ratings_total || 12222
              } reviews on Google`}</p>

              <SeeReviews />
            </div>
            {/* Rating CTA */}
            <Button
              data={{
                name: widgetData?.widgetCta || 'Rate us on google',
                link: 'https://www.google.com/search?hl=en-IN&gl=in&q=ACKO+General+Insurance+Limited,+%2336/5,+Hustlehub+One+East,+Somasandrapalya,+27th+Main+Rd,+Sector+2,+HSR+Layout,+Bengaluru,+Karnataka+560102&ludocid=1641951772424297989&lsig=AB86z5XTfbqiCeKddjq1bQb0cU6X#lrd=0x3bae145b3b40270d:0x16c9627005ac5e05,3',
                ctaType: 'GreenSubmitCta',
              }}
              segmentEventCommonProperties={data?.segmentEventCommonProperties}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default googleRating
